<div>
  <div id="printContent" #printContent>
    <div class="header-controls">
      <h3>
        <fa-icon [icon]="schoolAdminIcon"/>
        School Users
      </h3>
    </div>
    <div>
      <div class="section-header padding-bottom-0">
        <h5 class="section-header-detailed">
          <fa-icon [classes]="['print-hide']" [icon]="schoolUsersIcon"></fa-icon> Users List
        </h5>
      </div>
      <div class="boxed-content">
        <div class="text-button-bar">
          @if (message) {
            <div id="user-list-message" class="alert message" [ngClass]="{ 'alert-danger': messageStatus === 'error', 'alert-success' : messageStatus === 'success' }">
              <div class="icon">
                @if (messageStatus === 'success') {
                  <fa-icon [icon]="successIcon"></fa-icon>
                } @else if (messageStatus === 'error') {
                  <fa-icon [icon]="errorIcon"></fa-icon>
                }
              </div>
              <div>
                <div class="bold">{{ messageTitle }}</div>
                {{ message }}
              </div>
            </div>
          }
          <div class="button-bar">
            <button type="button" class="btn btn-success" (click)="addSchoolUser()">
              <fa-icon [icon]="addSchoolUserIcon"></fa-icon> Add
            </button>
            <button type="button" class="btn btn-danger" [disabled]="!usersSelected || isDeleting" (click)="archiveSchoolUsers()">
              @if (!isDeleting) {
                <fa-icon [icon]="deleteSchoolUserIcon"></fa-icon>
              } @else {
                <fa-icon [icon]="loadingIcon" [spin]="true"></fa-icon>
              }
              Archive
            </button>
          </div>
        </div>
        <table class="report-table">
          <thead>
          <tr>
            <th class="print-hide"></th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Active Students</th>
          </tr>
          </thead>
          <tbody>
            @for (user of users ; track user.userID) {
              <tr>
                <td class="print-hide select-edit-cell">
                  <input type="checkbox" (change)="userToggled($event)" [value]="user.userID" [disabled]="user.numberOfActiveStudents ?? 0 > 0">
                  <button type="button" class="btn btn-sm" title="Edit Student" (click)="editUser(user.userID)"><fa-icon [icon]="editSchoolUserIcon"></fa-icon></button>
                </td>
                <td>{{ user.firstName }}</td>
                <td>{{ user.lastName }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.userRole | displayUserRole }}</td>
                <td>{{ user.numberOfActiveStudents ?? 0 }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
